import _ from 'lodash';

/**
 * Turns a YouTube watch link from the support content into a privacy-friendly embed url. The last path segment is taken and its watch?v= prefix stripped to form the video id appended to the youtube-nocookie embed base, while a falsy input yields undefined.
 *
 * @param value - YouTube watch url to convert.
 * @returns Embeddable youtube-nocookie url, or undefined for a falsy input.
 */
const handleUrlYoutube = (value: any) => {
  if (value) {
    const splitValue = value?.split('/');
    const id = _.replace(splitValue?.[splitValue.length - 1], 'watch?v=', '');
    // return `https://www.youtube-nocookie.com/embed/${value.slice(17)}`;
    return `https://www.youtube-nocookie.com/embed/${id}`;
  }
  return undefined;
};

export { handleUrlYoutube };
